import { PageEvent } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';
import { BehaviorSubject } from 'rxjs';
import { AccessGroupCarType } from 'src/app/shared/enums/access-group-car-type';
import { ChargingUserStatus } from 'src/app/shared/enums/charging-user-status.enum';
import { DiscountType } from 'src/app/shared/enums/discount-type.enum';
import { OrganizationType } from '../../shared/enums/organization-type.enum';

export interface AccessGroup {
  identifier: string;
  id: number;
  name: string;
  organizationId: number;
  organizationName: string;
  amount: number;
  discountType: DiscountType;
  accessCount: number;
  connectorCount: number;
  connectorIdentifiers: string[];
  created: Date;
  createdBy: string;
  highlight: BehaviorSubject<boolean>;
  isDeleted: boolean;
  chargingUserIdentifiers: string[];
  idTagIds: number[];
  customerNumbers: number[];
  carType: AccessGroupCarType;
  sharedDiscountIdentifier?: string;
  sharedDiscountName?: string | null;
}

export interface DefaultAccessGroup {
  identifier: string;
  name: string;
}

export class AccessGroupSearchEvent {
  constructor(paging: PageEvent) {
    this.paging = paging;
    this.sorting = null;
  }
  query: string | null;
  organizationId: number | null;
  chargingUserIdentifier?: string | null;
  idTagId?: number | null;
  accessGroupIdentifier?: string | null;
  connectorIdentifier?: string | null;
  sharedAccessGroupDiscountIdentifier?: string | null;
  chargingStationLocationIdentifier?: string | null;
  carType?: AccessGroupCarType | null;
  paging: PageEvent;
  sorting: Sort | null;
}

export class AccessGroupUserSearchEvent {
  accessGroupIdentifier?: string;
  chargingUserStatuses?: ChargingUserStatus[];
}

export interface CreateAccessGroup {
  identifier?: string;
  organizationId: number;
  name: string;
  amount?: number | null;
  connectorIdentifiers: string[];
  carType: AccessGroupCarType;
  sharedDiscountIdentifier?: string | null;
}

export interface DefaultAccessGroup {
  identifier: string;
  name: string;
  type: OrganizationType;
  amountFixed: number;
  amountPercentage: number;
  carType: AccessGroupCarType;
  sharedDiscountPercentageIdentifier: string;
  sharedDiscountFixedIdentifier: string;
}
